import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

// MUI
import Skeleton from "@mui/material/Skeleton";

// Custom
import { GridContainer, GridItem } from "@/ui/Grid";
import imgService from "@/services/imgService";

// Types
import { DCRecord } from "@/@types/lib/dataController";
import { Box } from "@mui/material";
import { Clip } from "../ObjectAnalysisImage";

interface ObjektiSlikeViewProps {
  imgData?: any | null;
  selectedObjekt: DCRecord;
  baseRecordPath: string;
}

// const imgs = [img1, img2];
const IMAGE_WIDTH = 400;

function ObjektiSlikeView(props: ObjektiSlikeViewProps) {
  const { selectedObjekt, imgData } = props;
  const { baseRecordPath } = props;

  const [img1, setImg1] = useState<DCRecord | null>(null);
  const [img2, setImg2] = useState<DCRecord | null>(null);
  const { t } = useTranslation();

  let mounted = false;

  useEffect(() => {
    mounted = true;
    return () => { mounted = false; }
  }, [])

  const parseClip = (input: string) => {
    const num = input.split(",").map(x => parseInt(x, 10));
    const x = num[0];
    const y = num[1];
    const w = num[2];
    const h = num[3];
    return [x, y, x + w, y + h] as Clip;
  }

  useEffect(() => {
    if (selectedObjekt.id) {
      if (selectedObjekt.foto_1) {
        const clip1 = parseClip(selectedObjekt.foto_1_extent as string);
        imgService.getObjImage(baseRecordPath, selectedObjekt.id as number, selectedObjekt.foto_1 as number, IMAGE_WIDTH, clip1).then(resp => {
          if (resp.success) {
            setImg1(resp.data as DCRecord);
          }
        }).catch(resp => console.error(resp));
      }
      if (selectedObjekt.foto_2) {
        const clip2 = parseClip(selectedObjekt.foto_2_extent as string);
        imgService.getObjImage(baseRecordPath, selectedObjekt.id as number, selectedObjekt.foto_2 as number, IMAGE_WIDTH, clip2).then(resp => {
          if (resp.success) {
            setImg2(resp.data as DCRecord);
          }
        }).catch(resp => console.error(resp));
      }
    }
  }, [selectedObjekt]);

  // useEffect(() => {
  //   if (objExtent && objExtent.length === 4) {
  //     setImg3(null);
  //     const bufferValue = Math.max(objExtent[3] - objExtent[1], objExtent[2] - objExtent[0]) * 0.9;
  //     imgService.getImage(baseRecordPath, selectedObjektId, 3, 400, buffer(objExtent, bufferValue).join(',')).then(resp => {
  //       if (resp.success && resp.data) {
  //         // if (mounted) {
  //           setImg3(resp.data as DCRecord);
  //         // }
  //       }
  //     });
  //   }
  // }, [objExtent]);

  return (
    <Box>
      {
        new Array(3).fill(null).map((_, i) => (
          <Box>
            {
              i === 0 ?
                `${t("objekti.kat_no")}: ${imgData ? imgData.kat + 1 : ""}`
                : i === 1 ?
                  `${t("objekti.ukupno")}: ${imgData && imgData ? imgData.ukupno : ""} m²`
                  : ""
              // `${t("objekti.id")}: ${(selectedObjekt.id as number) % 1000000}`
            }
          </Box>
        ))
      }
      <GridContainer p={5}>


        {
          [img1, img2].map((img, i) => (
            <GridItem key={i} sm={12} md={6} lg={6} p={0} style={{ textAlign: "center" }}>
              {
                img && img.image ?
                  <img
                    src={`data:image/jpeg;charset=utf-8;base64,${img.image as string}`}
                    style={{ display: "inline-block", maxWidth: "100%", width: "80%" }}
                  />
                  : <Skeleton animation="wave" variant="rectangular" width={IMAGE_WIDTH} height={IMAGE_WIDTH} />
              }
            </GridItem>
          ))
        }

      </GridContainer>
    </Box>

  );
}

export default ObjektiSlikeView;